// Pure slot math shared by RoomAvailabilityPanel and ProviderConflictModal (ENG-1831).
// Both surfaces must agree on what "free" means — a duplicated bug here sends a booking
// to a time that is already taken, so this is deliberately the single implementation.

export type Interval = { start: Date; end: Date };

export const DEFAULT_MIN_FREE_SLOT_MINUTES = 15;

// Position relative to the range START INSTANT (not just its hour) so a window that touches or
// crosses midnight — whose getHours() wraps to 0 — still maps to the right side of the scale.
export function toPercent(
  dt: Date,
  rangeStart: Date,
  totalMinutes: number
): number {
  const mins = (dt.getTime() - rangeStart.getTime()) / 60000;
  return Math.max(0, Math.min(100, (mins / totalMinutes) * 100));
}

export function computeFreeSlots(
  busy: Interval[],
  rangeStart: Date,
  rangeEnd: Date,
  minSlotMinutes: number = DEFAULT_MIN_FREE_SLOT_MINUTES
): Interval[] {
  const sorted = [...busy].sort(
    (a, b) => a.start.getTime() - b.start.getTime()
  );
  const free: Interval[] = [];
  let cursor = rangeStart.getTime();

  for (const b of sorted) {
    const bStart = Math.max(b.start.getTime(), rangeStart.getTime());
    const bEnd = Math.min(b.end.getTime(), rangeEnd.getTime());
    if (bStart > cursor)
      free.push({ start: new Date(cursor), end: new Date(bStart) });
    if (bEnd > cursor) cursor = bEnd;
  }
  if (cursor < rangeEnd.getTime())
    free.push({ start: new Date(cursor), end: rangeEnd });

  return free.filter(
    (s) => s.end.getTime() - s.start.getTime() >= minSlotMinutes * 60 * 1000
  );
}
